import React from 'react';
import styled from 'styled-components';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import Node from 'craft/components/Node';
import { createVariantsSelector } from 'craft/components/SelectedToolbar/VariantsSelector';
import { AtomicText } from 'craft/resolvers/AtomicText';
import { ButtonBadgesVariantSelectorToolbox } from 'craft/resolvers/Button';
import { TypographyStyles } from 'craft/resolvers/Typography/toolbox';
import { Resolver, ToolboxComponentSections } from 'craft/types';

export const StyledBadge = styled.div`
  cursor: pointer;
  white-space: nowrap;

  &:focus {
    outline: none;
  }
`;

interface Props {
  color: string;
  childrenString: string;
  outline?: string;
  variant?: string;
}

export const Badge: Resolver<Props> = ({ color, childrenString, variant, outline }: Props) => {
  const colorMatchedVariant = color === 'primary' ? 'base' : color;
  const appearanceStyle = outline === 'light' ? '_light' : '';
  const badgeVariant = {
    variant: variant || `${colorMatchedVariant}${appearanceStyle}` || 'base',
  };
  const sssClassname = toCssSelector('badge', {
    variant: badgeVariant,
    output: 'html',
  });
  return (
    <Node
      data-atomictext-node
      data-cy-props={outline}
      css={{ display: 'inline-block' }}
      is={StyledBadge}
      color={color}
      solid={outline === 'solid'}
      className={sssClassname}
    >
      <AtomicText data-cy="node-badge-title" childrenString={childrenString} />
    </Node>
  );
};

Badge.craft = {
  name: 'Badge',
};

Badge.toolbox = {
  component: [TypographyStyles],
  schema: {
    [ToolboxComponentSections.NameAndType]: {
      variantSelector: ButtonBadgesVariantSelectorToolbox,
    },
    [ToolboxComponentSections.Layout]: {
      blockedDisplays: ['flex'],
    },
    [ToolboxComponentSections.Size]: {
      hasOverflow: true,
    },
    [ToolboxComponentSections.Background]: {
      hasDefaultValue: true,
    },
  },
};

Badge.selectedToolbar = {
  customItems: [
    createVariantsSelector({
      componentName: 'badge',
      getConditions: (props) => {
        const colorMatchedVariant = props.color?.value === 'primary' ? 'base' : props.color?.value;
        const appearanceStyle = props.outline?.value === 'light' ? '_light' : '';
        return {
          name: props.variant?.value || `${colorMatchedVariant}${appearanceStyle}` || 'base',
        };
      },
      variantToProps: (variant) => variant.conditions,
    }),
  ],
};
